import React, { useState } from 'react';
import './EmailSignup.css';
import { supabase } from '../lib/supabase';

const EmailSignup = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const { error } = await supabase
        .from('email_signups')
        .insert([{ email: email.toLowerCase().trim() }]);

      if (error) {
        if (error.code === '23505') {
          setStatus('error');
          setMessage('This email is already signed up!');
        } else {
          throw error;
        }
      } else {
        setStatus('success');
        setMessage('Thanks for signing up!');
        setEmail('');
      }
    } catch (error) {
      console.error('Error:', error);
      setStatus('error');
      setMessage('Something went wrong. Please try again.');
    }

    setTimeout(() => {
      setStatus('idle');
      setMessage('');
    }, 3000);
  };

  return (
    <section id="signup" className="email-signup">
      <div className="signup-content">
        <h3>Join Our Growing Village</h3>
        <form onSubmit={handleSubmit} className="signup-form">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="email-input"
            required
            disabled={status === 'loading'}
          />
          <button
            type="submit"
            className="submit-button"
            disabled={status === 'loading'}
          >
            {status === 'loading' ? 'Signing up...' : 'Sign Up'}
          </button>
        </form>
        {message && (
          <p className={`signup-message ${status}`}>{message}</p>
        )}
      </div>
    </section>
  );
};

export default EmailSignup;